import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ColorPaletteExtractor from '../../components/ColorPaletteExtractor';

const PalettePage: React.FC = () => (
  <ToolLayout
    title="Color Palette Extractor - Extract Colors from Image | AllTools"
    description="Extract dominant color palettes from images. Export as CSS, JSON, or Tailwind config. Free tool."
    canonicalPath="/color-palette-extractor"
  >
    <ColorPaletteExtractor />
  </ToolLayout>
);

export default PalettePage;
